import {Inject, Injectable} from '@angular/core';
import {mbeConfigService} from './mbe-config.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {BasicResponse} from '@auth-suite-services/services';
import {
  BfgMessageLinkInterface,
  BfgMessageLinkInterfaceAPI,
  MessageLinkBfgidInterfaceAPI,
  MessageLinkDteInterfaceAPI,
  MessageLinkFinidInterfaceAPI
} from '../..';

@Injectable({
  providedIn: 'root',
})
export class BfgMessageLinkService {
  private URL;
  headers: HttpHeaders;

  constructor(
    @Inject(mbeConfigService) private config,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  // tslint:disable-next-line:max-line-length
  GetAllBFGMessageLink(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    bfgid: number
  ): Observable<BfgMessageLinkInterfaceAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<BfgMessageLinkInterfaceAPI>(
      `${this.URL}/bml/getallbfgmessagelink/${pageIndex}/${pageSize}/${
        sortActive ? sortActive : 'id'
      }/${sort ? sort : 'asc'}/${bfgid ? bfgid : 0}`,
      { headers }
    );
  }

  /** Get single BFG Message Link by id for edit view. Backend endpoint may be getbfgmessagelink or get1. 05/02/2026 PK. */
  GetBML(id: number): Observable<BfgMessageLinkInterface> {
    const headers = this.headers;
    return this.httpClient.get<BfgMessageLinkInterface>(
      `${this.URL}/bml/getbfgmessagelink/${id}`,
      { headers }
    );
  }

  CreateBML(bml: BfgMessageLinkInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Create bml: ' + JSON.stringify(bml));
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/bml/createbfgmessagelink`,
      bml,
      { headers }
    );
  }

  /** Update existing BFG Message Link; payload must include id. 05/02/2026 PK. */
  UpdateBML(bml: BfgMessageLinkInterface): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/bml/updatebfgmessagelink`,
      bml,
      { headers }
    );
  }

  GetAllFINID(instructionNo?: number): Observable<MessageLinkFinidInterfaceAPI> {
    const headers = this.headers;
    // const JSONObj = {
    //   InstructionNo: 297,
    // };
    // return this.httpClient.post<MessageLinkFinidInterfaceAPI>(
    //   `${this.URL}/bml/getallfinid`,JSONObj,
    //   { headers }
    // );
    // Use GET getallfinid and filter by instruction number client-side. 06/08/2026 PK.
    return this.httpClient
      .get<{ totalCount?: number; total_count?: number; items?: Array<Record<string, unknown>> }>(
        `${this.URL}/bml/getallfinid`,
        { headers }
      )
      .pipe(
        map((response) => {
          const items = (response.items ?? []).map((item) => {
            const id = Number(item['id']);
            const rno = Number(item['rno'] ?? item['InstructionNo'] ?? 0);
            const desc = String(item['desc'] ?? item['InstructionDescription'] ?? '');
            return {
              id,
              rno,
              desc,
              InstructionNo: rno,
              InstructionDescription: desc,
              relatedFINID: id,
            };
          });
          const filtered =
            instructionNo != null && instructionNo !== ('' as unknown as number)
              ? items.filter((item) => item.InstructionNo === Number(instructionNo))
              : items;
          return {
            total_count: response.totalCount ?? response.total_count ?? filtered.length,
            items: filtered,
          };
        })
      );
  }

  GetAllBFGID(): Observable<MessageLinkBfgidInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient.get<MessageLinkBfgidInterfaceAPI>(
      `${this.URL}/bml/getallbfgid`,
      { headers }
    );
  }

  GetAllDTE(): Observable<MessageLinkDteInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient.get<MessageLinkDteInterfaceAPI>(
      `${this.URL}/bml/getalldte`,
      { headers }
    );
  }
}
